export const isQuotaExceededError = (err: unknown) => {
  return (
    err instanceof DOMException && (
      err.code === 22 ||
        err.code === 1014 ||
        err.name === 'QuotaExceededError' ||
        err.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    )
  )
}
